"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronLeft } from "lucide-react";
import Link from "next/link";

export default function BackToBlogButton({ className, size = "default", variant = "ghost" }) {
  return (
    <Button asChild variant={variant} size={size} className={cn("font-medium", className)}>
      <Link href="/blog">
        <ChevronLeft className="size-4" aria-hidden />
        Back to Articles
      </Link>
    </Button>
  );
}
